<template>
  <div>
    <v-card-actions>
      <v-card-title>TEAM</v-card-title>
      <v-btn fab small color="primary" @click="userAdd = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <project-team-view></project-team-view>
    <project-team-add
      :user-add="userAdd"
      :user-list="userList"
      @update-add-user-modal="updateUserModal"
    ></project-team-add>
  </div>
</template>
<script>
import ProjectTeamAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectTeamAdd";
import ProjectTeamView from "@/components/Projects/ProjectInnerCardsComp/ProjectTeamView";
import {mapActions} from "vuex";
export default {
  name: "ProjectTeam",
  components: {
    ProjectTeamAdd,
    ProjectTeamView,
  },
  props: ["users", "userList"],
  data() {
    return {
      userAdd: false,
    };
  },
  methods: {
    ...mapActions(["DeleteProjectUser", "showLoadingProcess", "closeLoading"]),
    updateUserModal(value) {
      this.userAdd = value;
    },
  },
};
</script>
